export default "__VITE_ASSET__rtMHJcfa__"